import { useQuery } from '@tanstack/react-query'

import { fetchValidatorsList } from '@/api'
import type { ValidatorsResponse } from '@/api/modules/staking'
import { queryKeys } from '@/queries/keys'
import type { PaginationParams } from '@/types'

interface UseValidatorsListOptions {
  pagination?: PaginationParams
  staleTime?: number
  refetchInterval?: number
}

export function useValidatorsList(options?: UseValidatorsListOptions) {
  const {
    data: validatorsData,
    isLoading,
    isError,
  } = useQuery<ValidatorsResponse>({
    queryKey: queryKeys.staking.validatorsList(),
    queryFn: () =>
      fetchValidatorsList({
        limit: options?.pagination?.limit ?? '1000',
        ...options?.pagination,
      }),
    staleTime: options?.staleTime ?? 60_000,
    refetchInterval: options?.refetchInterval,
  })

  return {
    validators: validatorsData?.validators ?? [],
    isLoading,
    isError,
  }
}
